import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { CookiesProvider } from "react-cookie";

import Footer from "./Footer";
import MarketingAttributionStore from "./MarketingAttributionStore";

const Layout = ({ children, className, location, layout }) => {
    return (
        <CookiesProvider>
            <div className={classNames("main", className)}>
                {/* hackish workaround for correct rendering of the Google Play icon - the first icon of this type to be displayed as visible, now as a child of a display: none node */}

                <MarketingAttributionStore location={location} />

                <main>{children}</main>
            </div>
            <Footer layout={layout} />
        </CookiesProvider>
    );
};

Layout.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    location: PropTypes.shape({
        href: PropTypes.string.isRequired,
        search: PropTypes.string,
    }).isRequired,
    layout: PropTypes.string,
};

export default Layout;
